import classNames from "classnames";
import React, { CSSProperties } from "react";
import { Icon, IconName } from "../components";
import { useI18n } from "../lib/i18n/i18n_provider";

interface ButtonProps {
  title: string;
  testID?: string;
  onPress?: () => void;
  disabled?: boolean;
  size?: "lg" | "md";
  icon?: IconName;
  appearance?: "filled" | "outline" | "flat";
  override?: {
    button?: {
      style: CSSProperties;
    };
  };
}

export function Button(props: ButtonProps) {
  const {
    appearance = "filled",
    title,
    icon,
    disabled,
    testID,
    onPress,
    size = "md",
    override,
  } = props;
  const { locale } = useI18n();

  return (
    <button
      data-testid={testID}
      disabled={disabled}
      className={classNames(
        "button",
        `button-appearance-${appearance}`,
        `button-size-${size}`,
        disabled && "button-disabled",
        `button-${locale.baseLanguageTag}`
      )}
      style={override?.button?.style}
      onClick={onPress}
    >
      {icon && (
        <div className="button-icon">
          <Icon size={18} name={icon} color="white" />
        </div>
      )}
      {title}
    </button>
  );
}
